import React from "react";

const LabelLevel = ({ level, color, bgColor, image, emoticon = false }) => {
    return (
        <div style={styles.label(color, bgColor)}>
            {emoticon ? (
                <div>
                    <div
                        style={{
                            display: "inline-block",
                            width: "25%",
                            marginRight: "1%",
                            marginBottom: "3%",
                        }}
                    >
                        <img src={image} width={"80%"} />
                    </div>
                    <div style={{ display: "inline-block", width: "74%" }}>
                        {level}
                    </div>
                </div>
            ) : (
                <div>{level}</div>
            )}
        </div>
    );
};

export default LabelLevel;

const styles = {
    label: (color, bgColor) => ({
        backgroundColor: bgColor,
        padding: "2px 14px",
        borderRadius: "30px",
        color: color,
        textAlign: "center",
        fontSize: '16px',
    }),
};
